import { render, staticRenderFns } from "./view-inventory.vue?vue&type=template&id=359d0e20&"
import script from "./view-inventory.vue?vue&type=script&lang=js&"
export * from "./view-inventory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports